import { inject, Injectable } from '@angular/core';

import { EmailSenderKindEnum } from '@core/automated-actions-types';
import { AutomationAction, AutomationActionType } from '@core/workflow-automations-types';
import { EditAutomationsWarnings } from '@recruitee/workflow-automations-types';

import { AutomationCacheService } from './automation-cache.service';

@Injectable()
export class EditAutomationWarningsService {
  private readonly automationCacheService = inject(AutomationCacheService);

  public getEditWarning(
    actions: AutomationAction[],
    isEditedForm: boolean,
  ): EditAutomationsWarnings {
    const otherChanges = isEditedForm;
    const wrongSenders = {
      [EmailSenderKindEnum.UserPerformingAction]: false,
      [EmailSenderKindEnum.Recruiter]: false,
      [EmailSenderKindEnum.HiringManager]: false,
    };
    let wrongSendTime = false;

    actions.forEach(action => {
      const initialAction = this.automationCacheService
        .getInitialAutomationData()
        ?.actions.find(a => a.uuid === action.uuid);

      if (
        (action.type === AutomationActionType.CandidateSendEmail &&
          initialAction?.type === AutomationActionType.CandidateSendEmail) ||
        (action.type === AutomationActionType.CandidateCancelScheduledEvents &&
          initialAction?.type === AutomationActionType.CandidateCancelScheduledEvents)
      ) {
        if (
          action.data.fromKind === EmailSenderKindEnum.UserPerformingAction ||
          action.data.fromKind === EmailSenderKindEnum.HiringManager ||
          action.data.fromKind === EmailSenderKindEnum.Recruiter
        ) {
          const wrongSenderNew = initialAction?.data.fromKind !== action.data.fromKind;
          wrongSenders[action.data.fromKind] = wrongSenders[action.data.fromKind] || wrongSenderNew;
        }

        if (
          action.type === AutomationActionType.CandidateSendEmail &&
          initialAction?.type === AutomationActionType.CandidateSendEmail
        ) {
          const wrongSendTimeNew =
            initialAction?.data.sendAtTimezone !== null && action.data.sendAtTimezone === null;
          wrongSendTime = wrongSendTime || wrongSendTimeNew;
        }
      }
    });

    return {
      wrongSenders,
      wrongSendTime,
      otherChanges,
    };
  }
}
